export default __webpack_public_path__ + "static/product9-4087bbd169a479920599a675cccb4d7b.png";